import { useEffect } from 'react';

export const useOpenChatEvents = ({ onOpen }) => {
  useEffect(() => {
    if (typeof onOpen !== 'function') return;

    const onSWMessage = (event) => {
      const { data } = event;
      if (data?.type === 'OPEN_CHAT' && data.chatId) {
        onOpen(data.chatId);
      }
    };
    const onWindowMessage = (event) => {
      const { data } = event;
      if (data?.type === 'OPEN_CHAT' && data.chatId) {
        onOpen(data.chatId);
      }
    };

    navigator.serviceWorker?.addEventListener('message', onSWMessage);
    window.addEventListener('message', onWindowMessage);

    return () => {
      navigator.serviceWorker?.removeEventListener('message', onSWMessage);
      window.removeEventListener('message', onWindowMessage);
    };
  }, [onOpen]);
};
